import { useContext } from 'react'
import { UgeEditorContext } from '../contexts/editor'
import { editorComponent, UgeEditorProps } from '../types/editor'
import { Container } from './style'

const Editor = ({ children }: UgeEditorProps) => {
    const { activeEditor } = useContext(UgeEditorContext)
    const ActiveEditor = editorComponent(activeEditor)

    return (
        <Container>
            <ActiveEditor>{activeEditor === 'default' && children}</ActiveEditor>
        </Container>
    )
}

export default Editor
